import * as React from 'react';

/** @deprecated Work with your designer to replace with one of the current illustrations (https://lens.loom.dev/illustrations/illustration-set). */
function IllustrationTroubleshooting(props) {
  return (
    <svg
      viewBox="0 0 110 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 55h99.984c0 27.61-22.375 50-50 50S5 82.61 5 55z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={10}
        strokeMiterlimit={10}
      />
      <path
        d="M55 105c27.614 0 50-22.386 50-50S82.614 5 55 5 5 27.386 5 55s22.386 50 50 50z"
        stroke="currentColor"
        strokeWidth={10}
        strokeMiterlimit={10}
      />
      <path
        d="M23.534 55C23.534 37.62 37.62 23.534 55 23.534c17.382 0 31.466 14.085 31.466 31.466"
        stroke="currentColor"
        strokeWidth={10}
        strokeMiterlimit={10}
      />
      <path
        d="M42.053 55c0-7.138 5.794-12.932 12.932-12.932 7.138 0 12.932 5.794 12.932 12.932"
        stroke="currentColor"
        strokeWidth={10}
        strokeMiterlimit={10}
      />
    </svg>
  );
}

export default IllustrationTroubleshooting;
